import React from "react";
import Pharma from "../../../places/pages/Pharmacy/PharmacyDoctor";
import AppLayoutAssistant from "../../../navigation/Layout/LayoutAssistant";

export default function AssistantPharmaciesPage() {
  return <Pharma LayoutComponent={AppLayoutAssistant} />;
}
